import React, { createContext, FC } from 'react';

import { Feature } from 'api';
import { useProtectedClient } from 'hooks';

export interface Features {
  legacyAuthDomain: boolean;
  featureFlagsV2: boolean;
}

const FeaturesContext = createContext<Features>({
  legacyAuthDomain: false,
  featureFlagsV2: false,
});

const FeaturesProvider: FC = ({ children }) => {
  const client = useProtectedClient();

  const features = client.features || [];
  const clientFeatures: Features = {
    legacyAuthDomain: features.includes(Feature.LegacyAuthDomain),
    featureFlagsV2: features.includes(Feature.FeatureFlagsV2),
  };

  return <FeaturesContext.Provider value={clientFeatures}>{children}</FeaturesContext.Provider>;
};

export { FeaturesContext, FeaturesProvider };
